import { TemplateControlType, TemplateControlAction, ControlActionType } from 'src/app/modules/management/store/communication-center';
import { SettingsWrapperControl } from './settings-wrapper-control';
import { TemplateControlService } from './template-control.service';

export interface IDesignControl {
  id: string;
  controlElement: HTMLElement;
  childContentElement: HTMLElement;
  controlTemplate: string;
  settingsTemplate: string;
  controlType: TemplateControlType;
  canEdit: boolean;
  canCopy: boolean;
  canDelete: boolean;

  appendControl(parentElement: HTMLElement): void;
  insertSiblingControl(siblingElement: HTMLElement): void;
  wireUpEvents(): void;
  writeDataAttributeValues(): void;
  edit(): void;
  cancel(): void;
  save(): void;
  copy(): void;
  destroy(): void;
  dragEnter(event: any): void;
  dragLeave(event: any): void;
  drop(event): void;
}

export abstract class DesignControl implements IDesignControl {
  public id: string;
  public controlType: TemplateControlType;
  public controlTemplate: string;
  public settingsTemplate: string;
  public controlElement: HTMLElement;
  public get childContentElement(): HTMLElement {
    return this.controlElement;
  }
  public settingsWrapperControl: SettingsWrapperControl;
  public canEdit = true;
  public canCopy = true;
  public canDelete = true;

  constructor(public document: Document, public templateControlService: TemplateControlService) {
    this.settingsWrapperControl = this.templateControlService.settingsWrapperControl;
  }

  public appendControl(parentElement: HTMLElement) {
    const container = document.createElement('template');
    container.innerHTML = this.controlTemplate;
    this.controlElement = container.content.firstElementChild as HTMLElement;

    parentElement.appendChild(this.controlElement);
    this.controlElement.style.zIndex = '10';

    this.writeDataAttributeValues();
  }

  public insertSiblingControl(siblingElement: HTMLElement) {
    const container = document.createElement('template');
    container.innerHTML = this.controlTemplate;
    this.controlElement = container.content.firstElementChild as HTMLElement;

    siblingElement.insertAdjacentElement('afterend', this.controlElement);
    this.controlElement.style.zIndex = '10';

    this.writeDataAttributeValues();
  }

  public wireUpEvents() {
    this.controlElement.onmouseover = this.handleMouseOver.bind(this);

    this.controlElement.ondragenter = this.handleDragEnter.bind(this);

    this.controlElement.ondragover = this.handleDragOver.bind(this);

    this.controlElement.ondragleave = this.handleDragLeave.bind(this);

    this.controlElement.ondrop = this.handleDrop.bind(this);
  }

  public writeDataAttributeValues() {
    this.controlElement.id = this.id;
    this.controlElement.setAttribute('id', this.id);
    this.controlElement.setAttribute('data-id', this.id);
    this.controlElement.setAttribute('data-control-type', TemplateControlType[this.controlType]);
  }

  handleMouseOver(event) {
    event.preventDefault();

    this.settingsWrapperControl.show(this);
  }

  handleDragEnter(event) {
    event.preventDefault();

    this.dragEnter(event);
  }

  handleDragOver(event) {
    event.preventDefault();
  }

  handleDragLeave(event) {
    event.preventDefault();

    this.dragLeave(event);
  }

  handleDrop(event) {
    event.preventDefault();

    this.drop(event);

    return false;
  }

  abstract edit(): void;

  abstract cancel(): void;

  abstract save(): void;

  destroy(): void {
    this.controlElement.remove();
  }

  abstract copy(): void;

  dragEnter(event: any): void {
    this.showDragDropLocation(event.srcElement);
  }

  dragLeave(event: any): void {
    this.hideDragDropLocation(event.srcElement);
  }

  drop(event): void {
    this.hideDragDropLocation(event.srcElement);

    const sourceElement: HTMLElement = event.srcElement;
    const actionData = event.dataTransfer.getData('text/plain');
    const action: TemplateControlAction = JSON.parse(actionData);

    if (action.actionType === ControlActionType.Move) {
      this.templateControlService.moveControl(action.sourceElementId, this);
    } else if (action.actionType === ControlActionType.Add) {
      this.templateControlService.insertSiblingControl(this, action.controlType);
    }
  }

  showDragDropLocation(elm: HTMLElement) {
    while (!!elm) {
      if (elm.nodeName === 'TD') {
        break;
      }
      elm = elm.parentElement;
    }

    if (!!elm) {
      elm.style.borderBottom = '2px solid var(--primary-color-600)';
    }
  }

  hideDragDropLocation(elm: HTMLElement) {
    while (!!elm) {
      if (elm.nodeName === 'TD') {
        break;
      }
      elm = elm.parentElement;
    }

    if (!!elm) {
      elm.style.borderBottom = '2px solid transparent';
    }
  }
}
